import { render, staticRenderFns } from "./ComboboxProduction.vue?vue&type=template&id=31b22828&scoped=true&"
import script from "./ComboboxProduction.vue?vue&type=script&lang=js&"
export * from "./ComboboxProduction.vue?vue&type=script&lang=js&"
import style0 from "./ComboboxProduction.vue?vue&type=style&index=0&id=31b22828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b22828",
  null
  
)

export default component.exports